import { useCallback, useContext } from 'react';
import AlertsContext from '~/context/common/AlertsContext';
import ShareToastContent from './ShareToastContent';
import styles from './ShareToastContent.module.css';

const useDisplayShareToast = () => {
  const { showToast } = useContext(AlertsContext);

  return useCallback(
    () =>
      showToast({
        className: styles.ShareToast,
        label: <ShareToastContent />,
        lifetime: 5000,
        position: 'top-center',
        severity: 'custom',
        showClose: false
      }),
    [showToast]
  );
};

export default useDisplayShareToast;
